export default __webpack_public_path__ + "static/media/icon-share-new.2586cf0a.svg";